import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import{ProductSearchRequestModel} from '../../core/interfaces/Common.interface';
import { map } from 'rxjs/operators';
import { Constants } from '../constants/constants';
// tslint:disable-next-line:max-line-length
import { CartItemsModel, UserModel, AddressModel, PaymentModel, CountryModel, ShoppingCartModel, ApplicationListModel } from '../models/ShoppingCart.model';
import { BaseService } from './base.service';
// import { FinalOrderSummaryModel } from '../models/OrderSummary.model';
import { appApiResources, defaultRequestModel,appVariables,appRoles } from '../constants/Common.constant';
import { HelperService } from './helper.service';
// tslint:disable-next-line:max-line-length
import { CreateAccountModel, CountryListModel, InstituteListModel, ProvinceModel, ProgramModel, GraduationYearModel } from '../models/CreateAccount.model';
import { Router, ActivatedRoute } from '@angular/router';
import { DEFAULT_PACKAGE_URL_PROVIDER } from '@angular/platform-browser-dynamic/src/compiler_factory';

// import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { Response, Headers, RequestOptions } from '@angular/http';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class ShoppingService {
  accountId: string;
  roleType: string;
  headers: Headers;
  private AppID = new BehaviorSubject('');
  currentMessage = this.AppID.asObservable();
  private CartItemsList = new BehaviorSubject([]);
  observeCartItems = this.CartItemsList.asObservable();
  private UserDetails = new BehaviorSubject(new UserModel());
  observeUserDetails = this.UserDetails.asObservable();
  private PreviousCartItemsList = new BehaviorSubject([]);
  observePreviousCartItems = this.PreviousCartItemsList.asObservable();
  // tslint:disable-next-line:max-line-length
  private DisplaySection = new BehaviorSubject({ 'Login': true, 'Address': false, 'Payment': false });
  observeDisplaySection = this.DisplaySection.asObservable();
  private Address = new BehaviorSubject(new AddressModel());
  observeAddress = this.Address.asObservable();
  private Payment = new BehaviorSubject(new PaymentModel());
  observePayment = this.Payment.asObservable();
  private AddressMode = new BehaviorSubject(false);
  observeAddressMode = this.AddressMode.asObservable();
  public BackToPageUrl = new BehaviorSubject('');
  observeBackToPageUrl = this.BackToPageUrl.asObservable();
  AllowRecursiveHit = true;

  private Token = new BehaviorSubject('');
  observeToken = this.Token.asObservable();


  CountryList_ForAPI: CountryListModel[] = [];
  private Countries = new BehaviorSubject(this.CountryList_ForAPI);
  observeCountries = this.Countries.asObservable();

  InstituteList_ForAPI: InstituteListModel[] = [];
  private Institutes = new BehaviorSubject(this.InstituteList_ForAPI);
  observeInstitutes = this.Institutes.asObservable();

  ProvinceList_ForAPI: ProvinceModel[] = [];
  private Provinces = new BehaviorSubject(this.ProvinceList_ForAPI);
  observeProvince = this.Provinces.asObservable();


  ProgramList_ForAPI: ProgramModel[] = [];
  private Program = new BehaviorSubject(this.ProgramList_ForAPI);
  observeProgram = this.Program.asObservable();


  GraduationYearsList_ForAPI: GraduationYearModel[] = [];
  private GraduationYears = new BehaviorSubject(this.GraduationYearsList_ForAPI);
  observeGraduationYears = this.GraduationYears.asObservable();

  private ApplicationList = new BehaviorSubject(Array(new ApplicationListModel()));
  observApplicationList = this.ApplicationList.asObservable();
  IsPromptShown = false;
  @Output() IsEmptyShoppingCart: EventEmitter<boolean> = new EventEmitter();
  @Output() IsValidPromoCodeApplied: EventEmitter<boolean> = new EventEmitter();
  @Output() IsAppIDChanged: EventEmitter<boolean> = new EventEmitter();

  @Output() IsLoggedIn: EventEmitter<boolean> = new EventEmitter();
  @Output() IsCartComponent: EventEmitter<boolean> = new EventEmitter();
  @Output() IsCheckoutComponent: EventEmitter<boolean> = new EventEmitter();
  @Output() IsOrderCompleteComponent: EventEmitter<boolean> = new EventEmitter();
  @Output() IsOrderDetailComponent: EventEmitter<boolean> = new EventEmitter();
  @Output() LogInHeader: EventEmitter<boolean> = new EventEmitter();

  @Output() AutoLogOut: EventEmitter<boolean> = new EventEmitter();
  @Output() SetTimerCall: EventEmitter<boolean> = new EventEmitter();
  @Output() LoggedInDetails: EventEmitter<any> = new EventEmitter();

  private myProductList = new BehaviorSubject<any>([]);
  observeMyProduct$ = this.myProductList.asObservable();

  private UpsellItemsList = new BehaviorSubject([]);
  observeUpsellItemsList = this.UpsellItemsList.asObservable();

  private WebOrderNumber = new BehaviorSubject('');
  observeWebOrderNumber = this.WebOrderNumber.asObservable();

  private IsLTICall = new BehaviorSubject(false);
  observeIsLTI = this.IsLTICall.asObservable();

  constructor(private http: BaseService, private helperService: HelperService,
  ) { }

  setAppID(appID: string) {
    this.AppID.next(appID);
  }
  setToken(token: string) {
    this.Token.next(token);
  }

  setOrderNumber(OrderNumber: string) {
    this.WebOrderNumber.next(OrderNumber);
  }
  setUserDetails(user: UserModel) {
    this.UserDetails.next(user);
  }
  setCartItems(cartItemsList: CartItemsModel[]) {
    this.CartItemsList.next(cartItemsList);
  }
  setPreviousCartItems(previousCartItemsList: CartItemsModel[]) {
    this.PreviousCartItemsList.next(previousCartItemsList);
  }



  setAddressMode(value: boolean) {
    this.AddressMode.next(value);
    this.helperService.setToLocalStorage(appVariables.addressMode, value.toString());
  }

  setDisplaySection(section: string) {
    this.helperService.setToLocalStorage(appVariables.displaySection, section);
    if (section === 'Login') {
      // tslint:disable-next-line:max-line-length
      this.DisplaySection.next({ 'Login': false, 'Address': true, 'Payment': false });
    } else if (section === 'Address') {
      // tslint:disable-next-line:max-line-length
      this.DisplaySection.next({ 'Login': false, 'Address': true, 'Payment': true });
      // this.helperService.setDisplaySectionToLocalStorage('ChangeAddress');
    } else if (section === 'ChangeAddress') {
      // tslint:disable-next-line:max-line-length
      this.DisplaySection.next({ 'Login': false, 'Address': true, 'Payment': false });
      // this.helperService.setDisplaySectionToLocalStorage('Address');
    } else if (section === 'LogOut') {
      // tslint:disable-next-line:max-line-length
      this.DisplaySection.next({ 'Login': true, 'Address': false, 'Payment': false });
    }
  }

  setIsLTI(value: boolean) {
    this.IsLTICall.next(value);
  }

  logIn(User: UserModel): Observable<any> {
    User.ApplicationID = this.helperService.getFromLocalStorage(appVariables.accessAppID);
    return this.http.post(appApiResources.login, JSON.stringify(User));
  }

  logOut(): Observable<any> {
    return this.http.post(appApiResources.logout, {});
  }
  validateInstructorConfimation(emailId: string): Observable<any> {
    return this.http.get(appApiResources.validateInstructorConfimation + '?emailId=' + emailId);
  }
  forgotPassword(User: UserModel): Observable<any> {
    User.AppID = this.helperService.getFromLocalStorage(appVariables.accessAppID);
    return this.http.post(appApiResources.forgotpassword, JSON.stringify(User));
  }

  GetAddressDetailsFromAPI(): Observable<any> {
    return this.http.post(appApiResources.address, {});
  }

  GetAddress() {
    this.GetAddressDetailsFromAPI()
      .subscribe(
        (response) => {
          if (response.Data) {
            this.Address.next(response.Data);
          }
        },
        (error) => { }
      );
  }
  GetPaymentDetailsFromAPI(): Observable<any> {
    return this.http.post(appApiResources.payment, {});
  }
  PlaceOrder(Payment: PaymentModel): Observable<any> {
    Payment.ExpirationDateMonth = Payment.SelectedExpirationDateMonth.Value;
    Payment.ExpirationDateYear = Payment.SelectedExpirationDateYear.Value;
    return this.http.post(appApiResources.placeOrder, JSON.stringify(Payment));
  }
  AddShoppingCartItemsByLink(productid, promoCode, email, emailnumber, applicationid): Observable<any> {
    let queryParam = '?';
    queryParam += 'productid=' + productid;
    queryParam += (applicationid !== '') ? '&applicationid=' + applicationid : '&applicationid=';
    queryParam += (promoCode) ? '&promoCode=' + promoCode : '&promoCode=';
    queryParam += (email) ? '&email=' + email : '&email=';
    queryParam += (emailnumber) ? '&emailnumber=' + emailnumber : '&emailnumber=0';
    return this.http.post(appApiResources.AddShoppingCartItemsByLink + queryParam, {});
  }

  GetOrderDetails(Orderid): Observable<any> {
    let queryParam = '?';
    queryParam += 'Orderid=' + Orderid;
    return this.http.get(appApiResources.getOrderDetails + queryParam);
  }
  GetPaymentDetails() {
    this.GetPaymentDetailsFromAPI()
      .subscribe(
        (response) => {
          if (response.Data) {
            this.Payment.next(response.Data);
          }
        },
        (error) => { }
      );
  }

  RemoveAllItemsFromAPI(ShoppingCartGUID: string): Observable<any> {
    // let queryParam = '?';
    // queryParam += (ShoppingCartGUID !== '') ? 'ShoppingCartGUID=' + ShoppingCartGUID : 'ShoppingCartGUID=';
    return this.http.post(appApiResources.removeAllItem, { 'ShoppingCartGUID': ShoppingCartGUID });
  }

  validateIfProductassociatedWithAccount(ShoppingCartGUID: string)
  {
    return this.http.post(appApiResources.validateIfProductassociatedWithAccount, { 'ShoppingCartGUID': ShoppingCartGUID });
  }

  GetCartItemsFromAPI(promoCode: string, ShoppingCartGUID: string): Observable<any> {
    // tslint:disable-next-line:no-debugger
    // debugger;
    // const token: string = this.helperService.getFromLocalStorage(appVariables.accessTokenLocalStorage);
    // const appID: string = this.helperService.getFromLocalStorage(appVariables.accessAppID);
    // this.headers = new Headers();
    // this.headers.append('Content-Type', 'application/json');
    // this.headers.append('appId', '5');
    // const options = new RequestOptions({    });
    // const body = {
    //   // 'AccountID': 0,
    //   'PromoCode': '',
    //   'ShoppingCartGUID': '30DCD94B-6D4F-4F99-9D66-A69C95926D72',
    //   // 'ProductID': 0,
    //   // 'Quantity': 0,
    //   // 'ShoppingCartID': 0,
    //   // 'ProductIDs': 'string'
    // };
    // const headers = {headers: new Headers({ 'Content-Type': 'application/json'})};
    // const httpOptions = new RequestOptions(headers);



    // const httpOptions = {
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // };

    // let queryParam = '?';
    // queryParam += 'accountId=';
    // queryParam += (promoCode !== '') ? '&promoCode=' + promoCode : '&promoCode=';
    // queryParam += (ShoppingCartGUID !== '') ? '&ShoppingCartGUID=' + ShoppingCartGUID : '&ShoppingCartGUID=';
    return this.http.post(appApiResources.getCartItems, { 'promoCode': promoCode, 'ShoppingCartGUID': ShoppingCartGUID });
  }

  RemoveItemsFromAPI(productID: string, ShoppingCartGUID: string): Observable<any> {
    let queryParam = '?';
    queryParam += (productID !== '') ? 'productID=' + productID : 'productID=';
    queryParam += (ShoppingCartGUID !== '') ? '&ShoppingCartGUID=' + ShoppingCartGUID : '&ShoppingCartGUID=';
    return this.http.post(appApiResources.removeItem + queryParam, {});
  }

  UpdateItemsFromAPI(productID: string, quantity: string, ShoppingCartGUID: string): Observable<any> {
    let queryParam = '?';
    queryParam += (productID !== '') ? 'productID=' + productID : 'productID=';
    queryParam += (quantity !== '') ? '&quantity=' + quantity : '&quantity=';
    queryParam += (ShoppingCartGUID !== '') ? '&ShoppingCartGUID=' + ShoppingCartGUID : '&ShoppingCartGUID=';
    return this.http.post(appApiResources.updateItem + queryParam, {});
    // {'productID': productID, 'quantity': quantity, 'ShoppingCartGUID': ShoppingCartGUID }
  }
  SaveAddressDetailsFromAPI(address: AddressModel): Observable<any> {
     address.IsShoppingCart = true;
    if (address.SelectedCountry) {
      address.Country = address.SelectedCountry;
    }
    if (address.SelectedState && (address.SelectedCountry === 'USA' || address.SelectedCountry === 'KANA')) {
      address.State = address.SelectedState;
    }
    if (address.SelectedShippingCountry) {
      address.ShippingCountry = address.SelectedShippingCountry;
    }
    if (address.SelectedShippingState && (address.SelectedShippingCountry === 'USA' || address.SelectedShippingCountry === 'KANA')) {
      address.ShippingState = address.SelectedShippingState;
    }
    return this.http.post(appApiResources.saveaddress, JSON.stringify(address));
  }



  ReconcileShoppingCartItems(ShoppingCart: ShoppingCartModel): Observable<any> {
    return this.http.post(appApiResources.reconcileShoppingCartItems, JSON.stringify(ShoppingCart));
  }
  loadItems() {
    this.GetCartItemsFromAPI(this.helperService.getFromLocalStorage(appVariables.promoCode),
      this.helperService.getFromLocalStorage(appVariables.cartGUID))
      .subscribe(
        (response) => {
          if (response.Data) {
            this.setCartItems(response.Data);
            if (response.Data.length <= 0) {
              if (!this.IsPromptShown) {
                this.IsEmptyShoppingCart.emit(true);
              }
            }
          }
        },
        (error) => { }
      );
  }


  // Create Account
  GetCountries() {
    this.GetCountiresFromAPI()
      .subscribe(
        (response) => {
          this.Countries.next(response.Data);
        },
        (error) => { }
      );
  }

  GetCountiresFromAPI(): Observable<any> {
    return this.http.get(appApiResources.getCountries);
  }

  GetInstitute(zip: string = null, province?: number) {
    this.GetInstituteFromAPI(zip, province)
      .subscribe(
        (response) => {
          const appendOption = {
            InstituteID: 0,
            InstituteName: "other/my institution is not listed"
          };
          response.Data.splice(0, 0, appendOption);
          this.Institutes.next(response.Data);
        },
        (error) => { }
      );

  }

  GetInstituteFromAPI(zip: string = null, province?: number): Observable<any> {
    let queryParam = '?';
    if (zip != null) {
      queryParam += (zip !== '') ? 'zipCode=' + zip : 'zipCode=';
    } else {
      queryParam += (province !== 0) ? '&provinceCode=' + province : '&provinceCode=';
    }
    return this.http.get(appApiResources.getinstitute + queryParam);
  }

  GetProvince() {
    this.GetProvinceFromAPI()
      .subscribe(
        (response) => {

          this.Provinces.next(response.Data);
        },
        (error) => { }
      );
  }

  GetProvinceFromAPI(): Observable<any> {
    return this.http.get(appApiResources.getProvince);
  }

  GetProgram() {
    this.GetProgramFromAPI()
      .subscribe(
        (response) => {

          this.Program.next(response.Data);
        },
        (error) => { }
      );
  }
  GetProgramFromAPI(): Observable<any> {
    return this.http.get(appApiResources.getprogram);
  }

  GetGraduationYears() {
    this.GetGraduationYearsFromAPI()
      .subscribe(
        (response) => {

          this.GraduationYears.next(response.Data);
        },
        (error) => { }
      );
  }
  GetGraduationYearsFromAPI(): Observable<any> {
    return this.http.get(appApiResources.getyears);
  }

  checkExistingAccount(email: string): Observable<any> {
    return this.http.get(appApiResources.checkExistingAccount + '?emailId=' + email);
  }
  CreateAccount(registerform: CreateAccountModel): Observable<any> {
    registerform.AppId = +localStorage.getItem(appVariables.accessAppID);
    registerform.FirstName = registerform.FName;
    registerform.LastName = registerform.LName;
    registerform.Password = registerform.NewPassword;
    registerform.IsActive = true;
    registerform.Confirmed = true;
    registerform.CountryID = registerform.SelectedCountryID;
    // tslint:disable-next-line:max-line-length
    // if (registerform.SelectedCountry.CountryCode.toUpperCase().indexOf('CA') > -1 || registerform.SelectedCountry.CountryCode.toUpperCase().indexOf('US') > -1) {
    if(registerform.SelectedCountryID == appVariables.CountryID.Canada || registerform.SelectedCountryID == appVariables.CountryID.US)  {
    registerform.SelectedInstitute = JSON.parse(JSON.stringify(registerform.Institute));
      registerform.InstituteName = (registerform.SelectedInstitute.InstituteID == 0) ? registerform.OtherInstitue : registerform.SelectedInstitute.InstituteName;
      registerform.InstituteID = registerform.SelectedInstitute.InstituteID === null ? null : registerform.SelectedInstitute.InstituteID;

   //   if (registerform.SelectedCountry.CountryCode.toUpperCase().indexOf('CA') > -1) {
     if(registerform.SelectedCountryID == appVariables.CountryID.Canada) {
        registerform.SelectedProvince = JSON.parse(JSON.stringify(registerform.Province));
        registerform.ProvinceID = registerform.SelectedProvince.ProvinceID === null ? null : registerform.SelectedProvince.ProvinceID;
      } else {
        registerform.ProvinceID = null;
      }
    } else {
      registerform.InstituteName = registerform.OtherInstitue;
      registerform.InstituteID = null;
      registerform.ProvinceID = null;
      registerform.ZipCode = null;
    }

    registerform.CreateDateTime = Date.now();
    registerform.UpdateDateTime = Date.now();
    registerform.LastLoginDate = Date.now();
    registerform.AccountTypeName = 'student';
    return this.http.post(appApiResources.createaccount, JSON.stringify(registerform));
  }

  ValidateUniqueEmail(email, role) {
    return this.http.get(`${appApiResources.validateUniqueEmail}?emailId=${email}&role=${role}`).pipe(
      tap(res => res.Data));
  };

  GetApplicationListFromAPI(): Observable<any> {
    return this.http.get(appApiResources.applicationList);
  }

  GetParentProductImageFromAPI(productID: string, isbn?: string): Observable<any> {
    //  let queryParam = '?';
    //  queryParam += '&ProductIDs=' + productID;
    return this.http.get(appApiResources.getParentProductImageFromAPI + '?productID=' + productID + '&isbn=' + isbn);
  }

  Clear() {
    const AppID = this.helperService.getFromLocalStorage(appVariables.accessAppID);
    this.helperService.signOutUser();
    this.setUserDetails(new UserModel());
    this.setAppID(AppID);
    this.setCartItems([]);
    this.setToken('');
    this.helperService.setToLocalStorage(appVariables.accessAppID, AppID);
    this.setDisplaySection('LogOut');
    this.setIsLTI(false);
  }
  GetApplicationDetails() {
    this.GetApplicationListFromAPI()
      .subscribe(
        (response) => {

          this.ApplicationList.next(response.Data);

        },
        (error) => {
          // .status === 401
          if (error) {
            if (this.AllowRecursiveHit) {
              this.Clear();
              this.GetApplicationDetails();
              this.AllowRecursiveHit = false;
            }
          }
        }
      );
  }
  LoadScript(response): any {
  //FAD-1068 changes start
  this.helperService.setToLocalStorage(appVariables.AccountId, response.Data.AccountID.toString());
  this.helperService.setToLocalStorage(appVariables.FullName, response.Data.FirstName+' '+response.Data.LastName);
  this.helperService.setToLocalStorage(appVariables.email, response.Data.Email);
  
  let s = document.createElement('script'); s.type = 'text/javascript';
  s.async = true;
  s.src = 'https://services.fadavis.com/SharedJS/FADFullStory.js';
  // document.getElementsByTagName('head')[0].appendChild(s);
  //   let node = document.createElement('script');
  //   node.innerText = `
  //   FS.identify(` + response.Data.AccountID + `, {
  //       displayName: '` + response.Data.FirstName + ' ' + response.Data.LastName + ` ',
  //       email: '` + response.Data.Email + `',
  //       reviewsWritten_int: 14,
  //   });`;
  //   node.type = 'text/javascript';
  //   node.async = false;
  //   node.charset = 'utf-8';

  // //FAD-1068 changes end
    // document.getElementsByTagName('body')[0].appendChild(node);
    return s;
  }

  // LoadGoogleAnalyticScripts(): any {
  //   let node = document.createElement('script');
  //   node.innerText = `
  // window.dataLayer = window.dataLayer || [];
  // function gtag(){dataLayer.push(arguments);}
  // gtag('js', new Date());
  // gtag('config', 'UA-17211312-1');`;

  //   node.type = 'text/javascript';
  //   node.async = false;
  //   node.charset = 'utf-8';
  //   node.src = "https://www.googletagmanager.com/gtag/js?id=UA-17211312-1";
  //   return node;
  // }

  SetDefaultOnLoad(appID, GUID, TokenID, promoCode, isLTI) {
    if (GUID) {
      this.helperService.setToLocalStorage(appVariables.successOrderResponse, '');
      if (this.helperService.getFromLocalStorage(appVariables.cartGUID) !== GUID) {
        const PromoCode = this.helperService.getFromLocalStorage(appVariables.promoCode);
        this.helperService.signOutUser();
        this.helperService.setToLocalStorage(appVariables.promoCode, PromoCode);
      }
      this.helperService.setToLocalStorage(appVariables.cartGUID, GUID);
    }
    if (TokenID) {
      this.helperService.setToLocalStorage(appVariables.successOrderResponse, '');
      this.helperService.setToLocalStorage(appVariables.cartGUID, '');
      // this.helperService.setToLocalStorage(appVariables.promoCode, '');
      this.helperService.setToLocalStorage(appVariables.accessTokenLocalStorage, TokenID);
    }
    if (promoCode) {
      this.helperService.setToLocalStorage(appVariables.promoCode, promoCode);
    }
    if (appID) {
      this.setAppID(appID);
      this.helperService.setToLocalStorage(appVariables.accessAppID, appID);
    }
    if (isLTI) {
      this.helperService.setToLocalStorage(appVariables.isLTI, isLTI);
    }
    this.IsAppIDChanged.emit(true);
    this.GetApplicationDetails();

  }

  OnAddUpsellProductToCart(AppID: number, ProductIDs: number, Quantity: number, ShoppingCartGUID: string, AccountID: number, token: string): Observable<any> {
    let queryParam = '?';
    queryParam += (AppID !== 0) ? '&AppID=' + AppID : '&AppID=5';
    queryParam += '&ProductIDs=' + ProductIDs;
    queryParam += (Quantity !== 0) ? '&Quantity=' + Quantity : '&Quantity=1';
    queryParam += (ShoppingCartGUID !== '') ? '&GUID=' + ShoppingCartGUID : '&GUID=';
    queryParam += (AccountID !== 0) ? '&AccountID=' + AccountID : '&AccountID=0';
    queryParam += (token !== null) ? '&token=' + token : '&token=';

    return this.http.get(appApiResources.OnAddUpsellProductToCart + queryParam);
  }

  // To remove physical products from shopping cart   
  RemovePhysicalProductsFromAPI(productID: string, AccountID: number): Observable<any> {
    let queryParam = '?';
    queryParam += (productID !== '') ? 'productID=' + "" + productID + "" : 'productID=';
    queryParam += (AccountID !== 0) ? '&AccountID=' + AccountID : '&AccountID=0';
    return this.http.post(appApiResources.removePhysicalProducts + queryParam, {});
  }


  // RedirectToFADPage(ProductID: number): Observable<any>
  // {
  //   let queryParam = '?';
  //   queryParam = '&ProductIDs=' + ProductID ;
  //   return this.http.get(appApiResources.getProductDetailRedirectURL + queryParam);
  // }
  getSecretDataKey(emailId) {
    return this.http.get(`${appApiResources.GetSecretDataKey}?emailID=${emailId}`);
  }

  ResendConfirmationEmail(emailId) {
    return this.http.get(`${appApiResources.ResendConfirmationEmail}?emailId=${emailId}`).pipe(
      tap(res => res.Data));
  }

  CreateMarketoData() {
    let marketoResponseObject = JSON.parse(localStorage.getItem('marketoResponse'));
    let marketoRequestObject = JSON.parse(localStorage.getItem('marketoRequest'));

    return {
      "email": marketoResponseObject.Email,
      "accountId": 0,
      "location": `Create Account - Shopping Cart`,
      "requestObject": JSON.stringify(marketoRequestObject),
      "responseObject": JSON.stringify(marketoResponseObject),

    };
  }
  LogMarketoLeadData() {
    return this.http.post(`${appApiResources.LogMarketoLeadData}`, this.CreateMarketoData());
  }

  IsZipcodePatternValid(zipCodeControl: string) {
    let isValid = /^\d{5}(-\d{4})?$|^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$/.test(zipCodeControl);
    if (isValid) {
      return true;
    } else {
      return false
    };
  }

GetMyProductList(currentPage = defaultRequestModel.CurrPage,
        pageSize = defaultRequestModel.PageSize,
        productSortType = defaultRequestModel.ProductSortType, isForLocker = defaultRequestModel.isForLocker,
        SearchText=``): Observable<any> {
        this.accountId = this.helperService.getFromLocalStorage('AccountId');
        this.roleType = this.helperService.getFromLocalStorage('role') === appRoles.Instructor.toString() ? 'Instructor' : 'Student';
        const requestParam: ProductSearchRequestModel =
        {
            AccountID: this.accountId,
            CurrPage: currentPage,
            PageSize: pageSize,
            ProductSortType: productSortType,
            Role: this.roleType,
            isForLocker: isForLocker,
            SearchText: SearchText
        };
        return this.http.post(appApiResources.GetAllProductDetails, requestParam).pipe(map(res => {
            this.myProductList.next(res.Data);
            return res.Data;
        }))
    };
}



// WEBPACK FOOTER //
// ./src/app/core/services/shopping.service.ts